import { useState } from 'react';
import PropTypes from 'prop-types';
import { postJson } from '../global/func';
import logo from '../assets/images/logo-mark.png';

// Asking for a reset link.
//
// The answer is deliberately the same whether or not the address belongs to an
// account. Confirming that it does would let anyone check who your customers
// are, one address at a time, so the server never says -- and neither does this.
const ForgotPassword = ({ onBack }) => {

    const [email, setEmail] = useState('');
    const [busy, setBusy] = useState(false);
    const [error, setError] = useState('');
    const [sent, setSent] = useState('');

    const submit = async (e) => {
        e.preventDefault();

        if (email.trim() === '') {
            setError('Enter the email address you sign in with.');
            return;
        }

        setBusy(true);
        setError('');

        const url = encodeURI(import.meta.env.REACT_APP_API_SERVER_URL + '/auth/reset-request/');
        const result = await postJson(url, { email: email.trim() });

        setBusy(false);

        if (result.ok) {
            setSent(result.data?.message
                || 'If that address belongs to an account, a reset link is on its way.');
            return;
        }

        // A failure here is the request never arriving, not the address being
        // unknown -- the server answers the same either way.
        setError(result.status === 0
            ? 'Could not reach the server. Check your connection and try again.'
            : 'Something went wrong sending that. Please try again.');
    };

    return (
        <div className="column auth">
            <img className="auth__logo" src={logo} alt="Prayer Box" />
            <div>
                <h1 className="auth__title">
                    Reset your password

                </h1>
                <div>

                    {sent
                        ? <>
                            <div className="notice notice--info" role="status">{sent}</div>
                            <p className="card-text text-muted">
                                <small>
                                    Nothing arrived? Check your junk folder. The link expires in an
                                    hour, and asking again replaces any earlier one.
                                </small>
                            </p>
                          </>
                        : <>
                            <p className="card-text">
                                Enter the email address you sign in with and we will send you a link
                                to choose a new password.
                            </p>

                            <form onSubmit={submit}>
                                <div>
                                    <label htmlFor="reset-email">Email address</label>
                                    <input
                                        id="reset-email"
                                        name="reset-email"
                                        type="email"
                                        className="form-control form-control-lg"
                                        value={email}
                                        onChange={(e) => { setEmail(e.currentTarget.value); if (error) setError(''); }}
                                        autoComplete="email"
                                        autoFocus
                                        disabled={busy} />
                                </div>

                                {error &&
                                    <div className="notice notice--warn" role="alert">{error}</div>}

                                <button type="submit"
                                    className="btn btn--primary btn--block"
                                    disabled={busy}>
                                    {busy
                                        ? <>Sending...</>
                                        : <>Send me a reset link</>}
                                </button>
                            </form>
                          </>}

                    <button type="button"
                       
                        onClick={onBack}>
                        Back to sign in
                    </button>
                </div>
            </div>
        </div>
    );
};

ForgotPassword.propTypes = {
    onBack: PropTypes.func.isRequired,
};

export default ForgotPassword;
